import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import Layout from "./layoutStructure";

// theme material imports
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';


import { Scrollbars } from 'react-custom-scrollbars-2';

const query = graphql`
  query SiteTitleQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
    }
  }
`;

const darkTheme = createTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#F0C9B0'
    }
  },
});


function LayoutContainer(props) {
  const [showNav, setShowNav] = useState(false);

  function handleShowNav() {
    setShowNav(true);
  }

  function handleHideNav() {
    setShowNav(false);
  }

  const data = useStaticQuery(query);
  if (!data.site) {
    throw new Error(
      'Missing "Site settings". Open the Studio at http://localhost:3333 and some content in "Site settings"'
    );
  }

  let prevScrollPos = 0;
  // inside component:
  const handleScroll = (e) => {
    if (window && !window.matchMedia('(max-width: 720px)').matches) {
      if (e.top === 0) {
        document.getElementById("header").style.backgroundColor = "transparent";
  
      } else if (prevScrollPos > e.top) {
        document.getElementById("header").style.top = "0";
        document.getElementById("header").style.backgroundColor = "#292929";
  
      } else {
        document.getElementById("header").style.top = "-70px";
        document.getElementById("header").style.backgroundColor = "#292929";
      }
      prevScrollPos = e.top;
    } else {
      // handle burger menu transition
      if (e.top === 0) {
        document.getElementById("logoLinkSideMenu").style.pointerEvents ="none";
        document.getElementById("logoLinkSideMenu").style.opacity ="0";

        document.getElementById("header").style.backgroundColor = "transparent";
      } else {
        document.getElementById("logoLinkSideMenu").style.pointerEvents ="auto";
        document.getElementById("logoLinkSideMenu").style.opacity ="1";

        document.getElementById("header").style.top = "0";
        document.getElementById("header").style.backgroundColor = "#292929";
      }
    }
  };

  return (
    <Scrollbars 
      universal 
      style={{width: '100%', height: '100vh'}}
      renderThumbVertical={props => <div {...props} style={{backgroundColor: 'rgba(255, 255, 255, 0.7)'}} />}
      onScrollFrame={handleScroll}
      renderView={props => (
        <div {...props} id='renderViewScrollbar' style={{ ...props.style, position: 'fixed'}} />
      )}
      autoHide
    >
      <ThemeProvider theme={darkTheme}>
        <Layout
          {...props}
          showNav={showNav}
          siteTitle={data.site.title}
          onHideNav={handleHideNav}
          onShowNav={handleShowNav}
        />
      </ThemeProvider>    
    </Scrollbars>
  );
}

export default LayoutContainer;
